import React from 'react';
import { Select } from 'antd';

const AntdSelectCellRenderer = (props) => {
  const { value, colDef } = props;
  const { cellEditorParams } = colDef;
  const options = cellEditorParams?.values || [];

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
      <Select
        value={value}
        style={{ width: '100%' }}
        open={false}
        bordered={false}
      >
        {options.map((opt) => (
          <Select.Option
            key={opt}
            value={opt}
          >
            {opt}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default AntdSelectCellRenderer;
